import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { OwnerSyncPage } from "@/components/data-sources/owner-sync-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-sync/owners",
  loader: async () => {
    const [historyRes, mappingsRes, columnsRes, fieldsRes] = await Promise.all([
      fetch("/api/hubspot/owners/sync-history"),
      fetch("/api/owners/mappings"),
      fetch("/api/owners/mappable-columns"),
      fetch("/api/owners/hubspot-fields"),
    ]);
    const historyData = historyRes.ok ? await historyRes.json() : { results: [] };
    const mappingsData = mappingsRes.ok ? await mappingsRes.json() : { mappings: [] };
    const columnsData = columnsRes.ok ? await columnsRes.json() : { columns: [] };
    const fieldsData = fieldsRes.ok ? await fieldsRes.json() : { fields: [] };
    return {
      ownerSyncHistory: historyData.results ?? [],
      mappings: mappingsData.mappings ?? [],
      mappableColumns: columnsData.columns ?? [],
      hubspotFields: fieldsData.fields ?? [],
    };
  },
  component: OwnerSyncPageGuard,
});

function OwnerSyncPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <OwnerSyncPage />;
}
